<template>
    <div class="w-100">
        <div class="banner d-block d-lg-none" v-if="title && title.length && mobile">
            <span class="d-block text-center"><span class="icons-credit-card1 text-success font-20 align-center"></span>
                {{ __('messages.to') }} {{ months }} {{ title }}</span>
        </div>
        <div class="card card-info-list mt-3 d-none d-lg-block" v-if="title && title.length && !mobile">
            <div class="card-body p-0">
                <span class="d-block text-center"><span
                        class="icons-credit-card1 text-success font-20 align-center"></span> {{ __('messages.to') }} {{
                            months }} {{ title }}</span>
            </div>
        </div>
    </div>
</template>

<script>

import { PaymentOptionsServices } from '../../services/PaymentOptionsService'

export default {
    props: ['msiIsAvailible', 'mobile'],
    data() {
        return {
            data: {},
            title: "",
            months: 0
        };

    },
    async mounted() {
        await this.getPayments();
    },
    methods: {
        async getPayments() {
            let response = await PaymentOptionsServices.GetPayment();
            if (response) {
                this.data = response;
                let _title = (this.data.monthInterestFree ? this.data.monthInterestFree.title : null) || (this.data.otherPayments ? this.data.otherPayments.title : null) || "";
                let splititle = _title.split(" ");
                this.title = _title.substr(splititle[0].length + 1, _title.length);
                this.months = splititle[0];
                if (this.msiIsAvailible.length > 0) {
                    this.months = Math.max(...this.msiIsAvailible);
                    this.title = this.__("messages.with_credit_card")
                }
            }

        }
    },
    components: {

    }
}
</script>
